module.exports = __webpack_public_path__ + "img/vietnam.ce6e83c9.svg";